
































import invetarioModule from "@/store/modules/invetario-module";
import { Component, Vue } from "vue-property-decorator";
import VueQr from "vue-qrcode-component";
@Component({
  components: { VueQr },
})
export default class PrintingInventario extends Vue {
  created() {
    invetarioModule.getinvetarios();
  }

  get datasource() {
    return invetarioModule.invetarios.filter((x) => x.id_sub_inventario === 0);
  }
  GetUrlMovile(id: number) {
    return (
      document.location.origin +
      document.location.pathname +
      "#/main/inventario/readqr/" +
      id
    );
  }
}
